import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const ImageSlider: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/4SpwaRdQ2fycsgRtD9iWy5/vfvfv.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/71LHJfrm1M3EgMaBNevw1r/vtgt.png'];
  const nextSlide = () => {
    setCurrentSlide(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentSlide]);
  return <div className="relative h-[500px] md:h-[600px] overflow-hidden" data-id="element-83">
      {/* Sliding Images */}
      {images.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${currentSlide === index ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} data-id="element-84">
          <div className="absolute inset-0 bg-black/40 z-10" data-id="element-85"></div>
          <img src={image} alt={`Slide ${index + 1}`} className="w-full h-full object-cover" data-id="element-86" />
        </div>)}

      {/* Static Text Content */}
      <div className="absolute inset-0 flex items-center z-20" data-id="element-87">
        <div className="container mx-auto px-4" data-id="element-88">
          <div className="max-w-2xl text-white" data-id="element-89">
            <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-90">
              From Bump to Baby, and Beyond
            </h1>
            <p className="text-xl md:text-2xl mb-2 font-medium" data-id="element-91">
              Empowering Every Stage of Early Motherhood
            </p>
            <p className="text-lg md:text-xl mb-8" data-id="element-92">
              Helping pregnant women and nursing mothers maximize the experience
              with expert guidance, community support, and essential resources.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-93">
              <a href="/shop" className="bg-brown text-cream px-8 py-3 rounded-full hover:bg-brown-dark transition-colors duration-300 text-center font-medium" data-id="element-94">
                Shop Now
              </a>
              <a href="https://selar.com/50131b4y7a" target="_blank" rel="noopener noreferrer" className="bg-white text-brown px-8 py-3 rounded-full hover:bg-cream transition-colors duration-300 text-center font-medium" data-id="element-95">
                Join Our Community
              </a>
              <a href="/offerings" className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-full hover:bg-white hover:text-brown transition-colors duration-300 text-center font-medium" data-id="element-96">
                Our Offerings
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation arrows */}
      <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 z-30 bg-white/30 hover:bg-white/50 rounded-full p-2 text-white transition-colors duration-300" aria-label="Previous slide" data-id="element-97">
        <ChevronLeft size={24} data-id="element-98" />
      </button>
      <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 z-30 bg-white/30 hover:bg-white/50 rounded-full p-2 text-white transition-colors duration-300" aria-label="Next slide" data-id="element-99">
        <ChevronRight size={24} data-id="element-100" />
      </button>

      {/* Dots navigation */}
      <div className="absolute bottom-6 left-0 right-0 z-30 flex justify-center gap-2" data-id="element-101">
        {images.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-colors duration-300 ${currentSlide === index ? 'bg-white' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-102" />)}
      </div>
    </div>;
};
export default ImageSlider;